/** O IFC activo em texto, indexado uma vez por modelo.
 *
 *  Indexar um IFC de 150 MB custa alguns segundos, por isso só se faz
 *  quando alguém pede (abrir o inventário, pré-visualizar uma
 *  importação) e guarda-se enquanto o modelo estiver carregado. Os
 *  bytes são os que o viewer já guardou ao abrir o ficheiro: não se
 *  volta a ler o disco. */

import { rawIfc } from '@viewer/lib/rawIfc'
import { ModeloStep } from '@viewer/lib/step/modeloStep'
import { bytesToLatin1 } from '@viewer/lib/stepText'

const cache = new Map<string, { bytes: Uint8Array; modelo: ModeloStep }>()

export function bytesDoModelo(modelId: string): Uint8Array | null {
  return rawIfc.getCachedBytes(modelId) ?? null
}

/** O ModeloStep do ficheiro original (sem as alterações pendentes).
 *  Null quando o modelo não veio de um IFC (um .frag não traz o texto). */
export function modeloEmTexto(modelId: string): ModeloStep | null {
  const bytes = bytesDoModelo(modelId)
  if (!bytes) return null
  const c = cache.get(modelId)
  if (c && c.bytes === bytes) return c.modelo
  const modelo = new ModeloStep(bytesToLatin1(bytes))
  cache.set(modelId, { bytes, modelo })
  return modelo
}

/** Um ModeloStep novo, para aplicar operações sem estragar o da cache. */
export function copiaEditavel(modelId: string): ModeloStep | null {
  const bytes = bytesDoModelo(modelId)
  return bytes ? new ModeloStep(bytesToLatin1(bytes)) : null
}

export function esquecerModelo(modelId: string): void {
  cache.delete(modelId)
}

/** Deixa o browser desenhar antes de uma conta pesada. Um temporizador e
 *  não um requestAnimationFrame: esse pára com o separador escondido, e
 *  a conta ficava à espera até a pessoa voltar. */
export function depoisDePintar(): Promise<void> {
  return new Promise((r) => setTimeout(r, 30))
}
